import {MenuItem, Select, SelectChangeEvent} from '@mui/material';
import {ReactNode} from 'react';
import ArrowDownSelectIcon from '@icons/ArrowDownSelectIcon';

interface IProps {
	placeholder?: string;
	value?: string;
	onChange?: ((event: SelectChangeEvent<string>, child: ReactNode) => void) | undefined;
	className?: string;
	children?: ReactNode[];
}

export default function SelectRez({placeholder, value, onChange, className, children}: IProps) {
	return (
		<Select
			sx={{color: 'grey.800', bgcolor: 'grey.50', borderColor: 'grey.100'}}
			size="small"
			fullWidth
			defaultValue="none"
			value={value}
			className={className}
			IconComponent={() => <ArrowDownSelectIcon/>}
			onChange={onChange}>
			<MenuItem disabled value="none">{placeholder}</MenuItem>
			{
				children
			}
		</Select>
	);
}
